import {Button, Typography} from "@material-ui/core";
import React, {useState} from "react";
import useOnloadEffect from "../useOnloadEffect";
import {useHistory} from "react-router-dom";

export default function AllEvents() {

    const [allEvents, setAllEvents] = useState([])

    const history = useHistory();

    const showEvent = (event) => history.push(`/events/${event.id}`)

    const getEvents = () => {
        fetch(`${process.env.REACT_APP_API_CALL}/events`,{
            credentials: 'include'
        })
            .then(response => response.json())
            .then(setAllEvents)
    }

    useOnloadEffect(() => {
        getEvents()
    })

    return (
        <div className="all-events">
            <Typography variant="h3">Events:</Typography>
            <ul>
                {
                    allEvents.map(event => {
                        return <li key={event.id}>{event.name} <Button
                            onClick={() => showEvent(event)}>Select</Button></li>
                    })
                }
            </ul>
        </div>
    )

}